import React from 'react'

export default function SalesReportDetails() {
  return <div>SalesD</div>;
}
